export class Specification {
  isSatisfiedBy (p) {
    return !!p;
  }
}
export class CompositeSpecification extends Specification {
  and (specification) {
    return new AndSpecification(this, specification);
  }
  or (specification) {
    return new OrSpecification(this, specification);
  }
  not (specification) {
    return new NotSpecification(specification);
  }
}
export class AndSpecification extends CompositeSpecification {
  constructor (left, right) {
    super();
    this.leftSpecification = left;
    this.rightSpecification = right;
  }

  isSatisfiedBy (o) {
    const left = this.leftSpecification.isSatisfiedBy(o);
    if (left) {
      return this.rightSpecification.isSatisfiedBy(o);
    }
    return this.leftSpecification.isSatisfiedBy(o)
      && this.rightSpecification.isSatisfiedBy(o);
  }
}

export class OrSpecification extends CompositeSpecification {
  constructor (left, right) {
    super();
    this.leftSpecification = left;
    this.rightSpecification = right;
  }

  isSatisfiedBy (o) {
    return this.leftSpecification.isSatisfiedBy(o) || this.rightSpecification.isSatisfiedBy(o);
  }
}

export class NotSpecification extends CompositeSpecification {
  constructor (specification) {
    super();
    this.specification = specification;
  }
  isSatisfiedBy (o) {
    return !this.specification.isSatisfiedBy(o);
  }
}

export class DynamicSpecification extends CompositeSpecification {
  constructor (func) {
    super();
    this.func = func;
  }
  isSatisfiedBy (o) {
    return typeof this.func === 'function' && this.func(o);
  }
}
